<template>
  <v-card class="elevation-0 mt-0" flat>
    <v-card-title>Alterar senha</v-card-title>
    <v-card-text>
      <v-form v-model="valid">
        <v-layout row wrap>
          <v-flex sm4 xs12>
            <v-text-field
              type="password"
              v-model="password"
              v-validate="'required|min:6|max:50'"
              data-vv-name="password"
              label="Senha atual"
              name="password"
              placeholder=""
              prepend-inner-icon="lock"
              required
              outlined
              dense
            ></v-text-field>
          </v-flex>
          <v-flex sm4 xs12>
            <v-text-field
              type="password"
              v-model="password_new"
              v-validate="'required|min:6|max:50'"
              data-vv-name="password_new"
              label="Nova senha"
              name="password_new"
              placeholder=""
              prepend-inner-icon="lock_outline"
              outlined
              dense
            ></v-text-field>
          </v-flex>
          <v-flex sm4 xs12>
            <v-text-field
              type="password"
              v-model="password_new_confirmation"
              v-validate="'required|min:6|max:50'"
              data-vv-name="password_new_confirmation"
              label="Confirme a nova senha"
              name="password_new_confirmation"
              placeholder=""
              prepend-inner-icon="lock_outline"
              required
              outlined
              dense
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        rounded
        class="px-5"
        color="primary"
        :loading="loading"
        :disabled="btnValidated"
        @click="changePassword"
        >Alterar senha</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import { resetPassword2 } from "@/services/auth.service.js";

export default {
  data: () => ({
    password: "",
    password_new: "",
    password_new_confirmation: "",
    loading: false,
  }),
  computed: {
    btnValidated() {
      return this.password && this.password_new && this.password_confirmation;
    },
  },
  methods: {
    async changePassword() {
      try {
        this.loading = true;
        const res = await resetPassword2({
          last_password: this.password,
          password: this.password_new,
          password_confirmation: this.password_new_confirmation,
        });
        console.log(res);
        window.getApp.sendSnackMessage("Senha alterada com sucesso!");
      } catch (error) {
        window.getApp.sendSnackMessage(error.message, "error");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
